import React, { useCallback, useState } from 'react';
import { PortalOverlay, Pane, Button, Flex, Text } from '@leverege/ui-elements';
import { QuaggaScanner, CodeInput } from '@leverege/ui-scanner-elements';
import { UseResponsiveBreakpoints } from '@leverege/molten/views';
import { DecodeHintType, BarcodeFormat } from '@zxing/library';
import S from './Scanner.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const zxOpts = new Map();
zxOpts.set(DecodeHintType.POSSIBLE_FORMATS, [BarcodeFormat.CODE_39, BarcodeFormat.CODE_128]);
zxOpts.set(DecodeHintType.ALLOWED_LENGTHS, 17);
zxOpts.set(DecodeHintType.TRY_HARDER, true);
function Scanner(props) {
  const {
    open,
    eventData,
    onClose,
    onScan,
    onImage,
    mobile
  } = props;
  const [showError, setShowError] = useState(false);
  const onError = useCallback(evt => {
    setShowError(true);
  });
  const onTryAgain = useCallback(() => {
    setShowError(false);
  });
  const onCancel = useCallback(() => {
    onClose();
  }, [setShowError]);
  return /*#__PURE__*/_jsx(PortalOverlay, {
    position: "center",
    show: open,
    closeOnEscape: false,
    closeOnDocumentClick: false,
    onClose: onClose,
    children: /*#__PURE__*/_jsxs(Pane, {
      variant: mobile ? 'mobileItemForm' : null,
      className: S.scannerContainer,
      children: [/*#__PURE__*/_jsx(Button, {
        icon: "fa fa-times fa-fw",
        onClick: onClose,
        className: S.scannerClose,
        variant: "secondaryIconic"
      }), /*#__PURE__*/_jsx(QuaggaScanner, {
        scanning: open,
        readers: ['code_39_reader', 'code_39_vin_reader', 'code_128_reader'],
        eventData: eventData,
        onChange: onScan
      }), /*#__PURE__*/_jsx(CodeInput, {
        zxOpts: zxOpts,
        variant: "upload",
        onChange: onImage,
        onError: onError,
        eventData: eventData,
        className: S.scannerUpload,
        children: "Upload"
      }), showError && /*#__PURE__*/_jsx(NotFoundDialog, {
        onTryAgain: onTryAgain,
        onCancel: onCancel
      })]
    })
  });
}
function NotFoundDialog(props) {
  const {
    onTryAgain,
    onCancel
  } = props;
  // eslint-disable-next-line
  const message = 'No barcode could be detected in the uploaded image. Please try again with a different image or enter the code manually';
  return /*#__PURE__*/_jsx(Pane, {
    ...props,
    className: S.notFoundDialog,
    children: /*#__PURE__*/_jsxs(Flex, {
      className: S.notFoundFlex,
      variant: "colL",
      align: "center",
      justify: "center",
      children: [/*#__PURE__*/_jsx("img", {
        width: 120,
        height: 120,
        alt: "No Device",
        src: "https://recovr-ui-assets.storage.googleapis.com/no_device.png"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "formTitle",
        children: "Barcode Not Found"
      }), /*#__PURE__*/_jsx(Text, {
        variant: "bodyCentered",
        children: message
      }), /*#__PURE__*/_jsx(Button, {
        onClick: onTryAgain,
        className: S.fullWidth,
        variant: "primary",
        children: "Try Again"
      }), /*#__PURE__*/_jsx(Button, {
        className: S.fullWidth,
        variant: "link",
        eventData: {
          screen: 'main',
          field: null
        },
        onClick: onCancel,
        children: "Cancel"
      })]
    })
  });
}
function ScannerMobile(props) {
  return /*#__PURE__*/_jsx(Scanner, {
    ...props,
    mobile: true
  });
}
function ScannerDesktop(props) {
  return /*#__PURE__*/_jsx(Scanner, {
    ...props,
    mobile: false
  });
}
const components = {
  small: ScannerMobile,
  big: ScannerDesktop
};
export default function ScannerResponsive(props) {
  return UseResponsiveBreakpoints(components, props);
}